var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExtend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1724382672345,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 7505,
    width: 26,
    height: 26,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M169.6 222.6c0-41.2 33.4-74.7 74.7-74.7H294c0.1 0 0.1 0 0.1-0.1V98.3c0-0.1 0-0.1-0.1-0.1h-49.6c-68.8 0-124.6 55.8-124.6 124.6v49.6c0 0.1 0 0.1 0.1 0.1h49.6c0.1 0 0.1 0 0.1-0.1v-49.8zM791.8 98.2h-49.6c-0.1 0-0.1 0-0.1 0.1v49.6c0 0.1 0 0.1 0.1 0.1h49.7c41.2 0 74.7 33.4 74.7 74.7v49.7c0 0.1 0 0.1 0.1 0.1h49.6c0.1 0 0.1 0 0.1-0.1v-49.6c0-68.9-55.8-124.6-124.6-124.6z m74.8 398.2c0-192.5-156-348.5-348.5-348.5S169.6 304 169.6 496.4c0 132 73.4 246.7 181.5 305.9 0.1 0 0.1 0.1 0 0.2l-81.8 92.1c-0.1 0.1 0 0.2 0.1 0.2h74.5l66.8-66.8h0.1c33.8 11 69.9 17 107.4 17s73.5-6.1 107.4-17h0.1l66.8 66.8H767c0.1 0 0.1-0.1 0.1-0.2l-81.8-92.1v-0.2c107.9-59.1 181.3-173.9 181.3-305.9z m-348.4 24.9c-13.8 0-25-11.2-25-25V298c0-14.7 12.1-26.6 26.7-25.5 12.9 0.9 23 11.7 23 24.8v174.2c0 0.1 0 0.1 0.1 0.1h148.6c14.7 0 26.6 12.1 25.5 26.7-0.9 12.9-11.7 23-24.8 23H518.2z",
    "p-id": 7506,
    fill: "#8a8a8a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtend);
export default __webpack_public_path__ + "static/media/extend.527654e9e6282a726f32470f0ef06f13.svg";
export { ForwardRef as ReactComponent };